/**
 * Статус пассажира, когда по нему не создано ни одно завление на возврат
 */export const SUBMITTED = 'submitted';
/**
 * Статус пассажира, когда по нему создано заявление на возврат, но решения по возврату еще не принято
 */
export const REFUNDING = 'refunding';
/**
 * Статус пассажира, когда по нему создано заявление на возврат, и возврат будет осуществлен
 */
export const APPROVED = 'approved';
/**
 * Статус пассажира, когда по нему создано заявление на возврат, и в возврате отказано
 */
export const REFUSED = 'refused';
export const STATUS_TITLES = {
  [REFUNDING]: I18n.t('components.Passenger.returnable'),
  [APPROVED]: I18n.t('components.Passenger.returned'),
  [REFUSED]: I18n.t('components.Passenger.refused'),
  [SUBMITTED]: ''
};